import styled, { keyframes } from 'styled-components/macro';
import { device } from '../styles/devices';
import { HashLink  } from 'react-router-hash-link';

export interface ISectionContainerProps {
  align?: 'left' | 'center' | 'right';
}

export interface IButtonContainerProps {
  align?: 'left' | 'center' | 'right' | 'space-evenly' | 'space-between';
}

export interface ILoadingSpinnerProps {
  show?: boolean;
}

export const PageLayoutContainer = styled.div`
  width: 100%;
  min-width: 260px;
  background-color: ${({ theme }) => theme.layout.background};
  box-shadow: ${({ theme }) => theme.shadow.box};
  padding: 0px 10px 10px 10px;
  margin: 0 0 100px;

  @media ${device.laptop} {
    width: 1080px;
    margin: 0 auto 100px;
  }
`;
export const Form = styled.form``;

export const Row = styled.div`
  display: flex;
  flex-direction: column;

  @media ${device.mobileLrg} {
    flex-direction: row;

    > * {
      margin-left: 5px;

      &:first-child {
        margin-left: 0;
      }
    }
  }
`;
export const SectionContainer = styled.div<ISectionContainerProps>`
  min-height: 440px;
  padding: 10px 10px;
  @media ${device.mobileMed} {
    padding: 20px 20px;
  }
  display: ${({ align }) => (align ? 'flex' : 'inherit')};
  flex-direction: ${({ align }) => (align ? 'column' : 'inherit')};
  justify-content: ${({ align }) =>
    align === 'left'
      ? 'flex-start'
      : align === 'center'
      ? 'center'
      : align === 'right'
      ? 'flex-end'
      : 'inherit'};
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media ${device.mobileLrg} {
    flex-direction: row;
  }
`;

export const FormSectionContainer = styled.div`
  @media ${device.mobileLrg} {
    &.activateCardSection,
    &.balanceSection {
      margin-right: 20px;
      width: 65%;
    }
    &.centered {
      margin: 0 auto;
    }
  }
`;

export const ButtonGroupContainer = styled.div<IButtonContainerProps>`
  display: flex;
  flex-direction: column;

  @media ${device.mobileLrg} {
    flex-direction: row;
    justify-content: ${({ align }) =>
      align === 'left'
        ? 'flex-start'
        : align === 'center'
        ? 'center'
        : align === 'right'
        ? 'flex-end'
        : align === 'space-evenly'
        ? 'space-evenly' 
        : align === 'space-between' ? 'space-between'
        : 'inherit'};
    .centerLeftBtn {
      margin-right: 20px;
    }
    .centerRightBtn {
      margin-left: 20px;
    }
  }
`;

export const Line = styled.div`
  height: 1px;
  width: 100%;
  margin: 0 auto;
  background-color: ${({ theme }) => theme.colors.primary.default};
`;

export const Image = styled.img`
  width: 100%;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  min-width: 240px;
  max-width: 440px;
  margin: 20px auto;
  border-radius: 12px;
  @media ${device.mobileLrg} {
    width: 70%;
  }
`;

export const ImageSplitFormSection = styled.img`
  width: 100%;
  object-fit: cover;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  min-width: 180px;
  max-width: 470px;
  margin: 10px 0;
  border-radius: 12px;
`;

export const ImageHeader = styled.img`
  width: 100%;
  max-width: 380px;
  cursor: pointer;
`;

export const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
export const LoadingSpinner = styled.div<ILoadingSpinnerProps>`
  animation: ${rotate360} 1s linear infinite;
  transform: translateZ(0);
  display: ${({ show }) => (show ? 'block' : 'none')};
  border: 10px solid ${({ theme }) => theme.colors.white.default};
  border-radius: 50%;
  border-top: 10px solid ${({ theme }) => theme.colors.primary.default};
  width: 35px;
  height: 35px;
  margin-top: 1.2em;
  margin: 0 auto;
  background: ${({ theme }) => theme.colors.primary.default};
`;



export const StyledLink = styled(HashLink)`
  color:  ${({ theme }) => theme.colors.white.default};
  padding: 5px 0;
  text-align: center;
`;

export const TermSection = styled.div`
margin: 10px 0;
`
